// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardThumbnail {
  display: grid;
  grid-gap: var(--spacing_unit_1);
  gap: var(--spacing_unit_1);
  flex-shrink: 0;
  height: 138px;
  overflow: hidden;
  background: var(--color_neutral_400);
  transition: 0.16s ease-in-out;
}
.CardThumbnail .place {
  overflow: hidden;
}
.CardThumbnail .place > img {
  width: 100%;
  height: calc(100% + 69px);
  transform: translateY(-34.5px);
  object-fit: cover;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  pointer-events: none;
}
.CardThumbnail .board-grid-place-1 {
  grid-area: place-1;
}
.CardThumbnail .board-grid-place-2 {
  grid-area: place-2;
}
.CardThumbnail .board-grid-place-3 {
  grid-area: place-3;
}
.CardThumbnail.board-grid-1 {
  grid-template-areas: "place-1";
}
.CardThumbnail.board-grid-2 {
  grid-template-columns: 0.66fr 0.34fr;
  grid-template-areas: "place-1 place-2";
}
.CardThumbnail.board-grid-3 {
  grid-template-columns: 0.66fr 0.34fr;
  grid-template-areas: "place-1 place-2" "place-1 place-3";
}
.CardThumbnail .isBriefingCard {
  position: absolute;
  right: 12px;
  top: 112px;
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardCard/components/CardThumbnail/index.scss"],"names":[],"mappings":"AAAA;EAIE,aAAA;EACA,+BAAA;EAAA,0BAAA;EACA,cAAA;EACA,aANe;EAOf,gBAAA;EACA,oCAAA;EACA,6BAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;AAGI;EACE,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,iBAAA;EAEA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,oBAAA;AAFN;AAKE;EACE,kBAAA;AAHJ;AAKE;EACE,kBAAA;AAHJ;AAKE;EACE,kBAAA;AAHJ;AAKE;EACE,8BAAA;AAHJ;AAKE;EACE,oCAAA;EACA,sCAAA;AAHJ;AAKE;EACE,oCAAA;EACA,wDACE;AAJN;AAQE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AANJ","sourcesContent":[".CardThumbnail {\n  $thumb-height: 138px;\n  $half-thumb-height: $thumb-height / 2;\n\n  display: grid;\n  gap: var(--spacing_unit_1);\n  flex-shrink: 0;\n  height: $thumb-height;\n  overflow: hidden;\n  background: var(--color_neutral_400);\n  transition: 0.16s ease-in-out;\n\n  .place {\n    overflow: hidden;\n    & > img {\n      width: 100%;\n      height: calc(100% + $half-thumb-height);\n      transform: translateY(-$half-thumb-height / 2);\n      object-fit: cover;\n\n      user-select: none;\n      pointer-events: none;\n    }\n  }\n  .board-grid-place-1 {\n    grid-area: place-1;\n  }\n  .board-grid-place-2 {\n    grid-area: place-2;\n  }\n  .board-grid-place-3 {\n    grid-area: place-3;\n  }\n  &.board-grid-1 {\n    grid-template-areas: 'place-1';\n  }\n  &.board-grid-2 {\n    grid-template-columns: 0.66fr 0.34fr;\n    grid-template-areas: 'place-1 place-2';\n  }\n  &.board-grid-3 {\n    grid-template-columns: 0.66fr 0.34fr;\n    grid-template-areas:\n      'place-1 place-2'\n      'place-1 place-3';\n  }\n\n  .isBriefingCard {\n    position: absolute;\n    right: 12px;\n    top: 112px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
